<div id="no-auto-quote-page-container">
    <div id="no-auto-quote-content">
        <div id="no-auto-quote-header_ffq-logo" title="Farmers &reg;" aria-label="Graphical Farmers Insurance Logo"></div>
        <div id="no-auto-quote_header-title" [innerHtml]="heading">
        </div>
        <div id="no-auto-quote_body_message" [innerHtml]="subHeading"></div>
        <div id="need_help">
            <div id="no-auto-quote_body_noagent"> Need more help?</div>
            <div id="no-auto-quote_body_call-custome">You can call customer service at</div>
            <span tabindex="0" [attr.aria-label]="desktopAriaLlabel">
                <div x-ms-format-detection = "none" class="no-auto-quote_desktop">
                    <a href={{teleDesktop}} id="no-auto-quote_body_farmers" tabindex="0" role="link">{{desktopNo}}</a>
                </div>
            </span>
            <span tabindex="0" [attr.aria-label]="mobileAriaLlabel">
                <div x-ms-format-detection = "none" class="no-auto-quote_mobile">
                    <a href={{teleMobile}} id="no-auto-quote_body_farmers" tabindex="0" role="link">{{mobileNo}}</a>
                </div>
            </span>
        </div>

        <div id="agent_button">
            <button (keyup.enter)="findAnAgent()" (click)="findAnAgent()" role= "presentation" tabindex= "0" aria-label="Let's find an agent button link" mat-button class="ffq-card-button-blue">
                <span class="find_agent_text">LET'S FIND AN AGENT</span> 
            </button>
        </div>
    </div>
</div>